import React, { useEffect, useState } from "react";

import { FormattedMessage } from "react-intl";

import { CwsModalBody } from "cms-web-styleguide/dist/components/CwsModal/CwsModalBody/CwsModalBody";
import { CwsP } from "cms-web-styleguide/dist/components/CwsTypography/CwsP/CwsP";
import { CwsTab } from "cms-web-styleguide/dist/components/CwsTab/CwsTab";
import { CwsTabItem } from "cms-web-styleguide/dist/components/CwsTab/CwsTabItem/CwsTabItem";
import { CwsTabContent } from "cms-web-styleguide/dist/components/CwsTab/CwsTabContent/CwsTabContent";
import { CwsTabContentItem } from "cms-web-styleguide/dist/components/CwsTab/CwsTabContent/CwsTabContentItem/CwsTabContentItem";

import { CookiePolicyTab } from "../CookiePolicyTab/CookiePolicyTab";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import { PrivacyPolicyTab } from "../PrivacyPolicyTab/PrivacyPolicyTab";
import { SelectionTab } from "../SelectionTab/SelectionTab";
import { TitleWithImg } from "../../components/TitleWithImg/TitleWithImg";

import styles from "./Popup.module.scss";

const Popup = (props) => {
  const { env, handleLocaleChange, locale, onSaveCookies } = props;

  const [targetReached, setTargetReached] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(min-width: 360px) and (max-width: 799px)");

    if (media.matches !== targetReached) {
      setTargetReached(media.matches);
    }

    const listener = () => setTargetReached(media.matches);

    window.addEventListener("resize", listener);

    return () => window.removeEventListener("resize", listener);
  }, [targetReached]);

  return (
    <CwsModalBody>
      <section className={styles["cwc-popup"]}>
        <div className={styles["cwc-popup__header"]}>
          <div className={styles["cwc-popup__header__inner"]}>
            <TitleWithImg inline />
            <Dropdown env={env} handleLocaleChange={handleLocaleChange} locale={locale} />
          </div>

          <CwsP hideSpacing>
            <FormattedMessage id="banner.description" />
          </CwsP>
        </div>
        <div className={`${styles["cwc-popup__content"]} cws-mt-m`}>
          <CwsTab mode={targetReached ? "fit-content" : null}>
            <CwsTabItem id="selection" label={<FormattedMessage id="popup.tab.label.selection" />} />
            <CwsTabItem id="cookie-policy" label={<FormattedMessage id="popup.tab.label.cookie.policy" />} />
            <CwsTabItem id="privacy-policy" label={<FormattedMessage id="popup.tab.label.privacy.policy" />} />
          </CwsTab>

          <CwsTabContent>
            <CwsTabContentItem id="selection">
              <SelectionTab onSaveCookies={(cookies) => onSaveCookies(cookies)} />
            </CwsTabContentItem>
            <CwsTabContentItem id="cookie-policy">
              <CookiePolicyTab locale={locale} />
            </CwsTabContentItem>
            <CwsTabContentItem id="privacy-policy">
              <PrivacyPolicyTab />
            </CwsTabContentItem>
          </CwsTabContent>
        </div>
      </section>
    </CwsModalBody>
  );
};

export { Popup };
